import PropTypes from 'prop-types'
import React from 'react'

const splitByFirstSpace = (value) => {
	if (!value || typeof value !== 'string') {
		return { primary: '', secondary: '' }
	}

	const spaceIndex = value.indexOf(' ')

	if (spaceIndex === -1) {
		return { primary: value, secondary: '' }
	}

	return {
		primary: value.slice(0, spaceIndex),
		secondary: value.slice(spaceIndex + 1),
	}
}

export const InstallmentInfo = ({ installmentInfo }) => {
	if (!installmentInfo?.enabled || !Array.isArray(installmentInfo?.options) || !installmentInfo.options.length) {
		return null
	}

	const { title, description, options } = installmentInfo

	return (
		<>
			<div className='vehicle-parts-orders__divider' style={{ margin: '1rem 3rem 0 3rem' }} />

			<section className='vehicle-part-installment-info'>
				{title ? (
					<h3 className='vehicle-part-installment-info__title'>{title}</h3>
				) : null}

				{description ? (
					<p className='vehicle-part-installment-info__description'>{description}</p>
				) : null}

				<div className='vehicle-part-installment-info__options'>
					{options.map((option, index) => {
						const monthsParts = splitByFirstSpace(option?.months_label)
						const amountParts = splitByFirstSpace(option?.amount_text)

						return (
							<div
								className='vehicle-part-installment-info__card'
								key={option?.months != null ? option.months : index}
							>
								<div className='vehicle-part-installment-info__card-header'>
									<span className='vehicle-part-installment-info__card-months'>{monthsParts.primary}</span>
									{monthsParts.secondary ? (
										<span className='vehicle-part-installment-info__card-months-label'>{monthsParts.secondary}</span>
									) : null}
								</div>
								<div className='vehicle-part-installment-info__card-body'>
									<span className='vehicle-part-installment-info__card-amount'>{amountParts.primary}</span>
									{amountParts.secondary ? (
										<span className='vehicle-part-installment-info__card-amount-label'>{amountParts.secondary}</span>
									) : null}
								</div>
							</div>
						)
					})}
				</div>
			</section>
		</>
	)
}

InstallmentInfo.propTypes = {
	installmentInfo: PropTypes.shape({
		enabled: PropTypes.bool,
		title: PropTypes.string,
		description: PropTypes.string,
		options: PropTypes.arrayOf(PropTypes.shape({
			months: PropTypes.number,
			amount: PropTypes.number,
			months_text: PropTypes.string,
			months_label: PropTypes.string,
			amount_text: PropTypes.string,
		})),
		defaultMonths: PropTypes.number,
	}),
}
